import afrobeatslogo from '../assets/images/afrobeats-logo.jpg'


const EventLogo = () => {

    return (
        <div className="rounded-full w-20 h-20 md:w-40 md:h-40 overflow-hidden ">
          <img className="w-full h-full" src={afrobeatslogo} alt="" />
        </div>
    )
}

export default EventLogo;